import { Box } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { Fragment, useState } from "react";
import { RadioButton } from "../../../commons/components/RadioButton";
import { useFormController } from "../../form/useFormController";
import { useMetadataAtomValue } from "../../metadataAtom";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { AddNewAccountNotification } from "./AddNewAccountNotification";
import { ErrorFieldNotification } from "./ErrorFieldNotification";
import { ExistingPayout } from "./ExistingPayout";
import { FirstPayoutNote } from "./FirstPayoutNote";
import { NewPayoutRadioGroup } from "./NewPayoutRadioGroup";
import { PayoutMode } from "./constants";

export const PayoutController = () => {
    const {
        cmsData: {
            pricing: { pleaseSelectAPayoutMethod, useAnExistingPayoutMethod, addNewPayoutMethod, useNewPayoutMethod },
        },
    } = useStaticDataAtomValue();
    const { value, setValue, fieldState, ref } = useFormController("payout", {
        rules: {
            required: pleaseSelectAPayoutMethod,
        },
    });
    const { payoutItems } = useMetadataAtomValue();

    const haveExistingPayout = payoutItems && payoutItems.length > 0;

    const [payoutMode, setPayoutMode] = useState<PayoutMode>(
        value?.id <= 0 || !haveExistingPayout ? PayoutMode.Create : PayoutMode.Existing,
    );

    const handleSelectPayoutMode = (payoutMode: PayoutMode) => () => {
        setValue(null);
        setPayoutMode(payoutMode);
    };

    if (!haveExistingPayout)
        return (
            <Fragment>
                <NewPayoutRadioGroup
                    value={value}
                    setValue={(value) => {
                        setValue(value);
                        setPayoutMode(PayoutMode.Create);
                    }}
                />
                <ErrorFieldNotification message={fieldState.error?.message} />
                {payoutMode === PayoutMode.Create && <AddNewAccountNotification />}
                <FirstPayoutNote />
            </Fragment>
        );

    return (
        <Fragment>
            <VStack gap="16">
                <RadioButton
                    ref={ref}
                    id="payout-mode-existing"
                    title={useAnExistingPayoutMethod}
                    isSelected={payoutMode === PayoutMode.Existing}
                    setValue={handleSelectPayoutMode(PayoutMode.Existing)}
                />
                {payoutMode === PayoutMode.Existing && (
                    <Box ps="24">
                        <ExistingPayout value={value} payoutItems={payoutItems} setValue={setValue} />
                    </Box>
                )}
            </VStack>
            <VStack gap="16">
                <RadioButton
                    ref={ref}
                    id="payout-mode-create"
                    title={addNewPayoutMethod}
                    description={useNewPayoutMethod}
                    isSelected={payoutMode === PayoutMode.Create}
                    setValue={handleSelectPayoutMode(PayoutMode.Create)}
                />
                {payoutMode === PayoutMode.Create && (
                    <Box ps="24">
                        <NewPayoutRadioGroup value={value} setValue={setValue} />
                    </Box>
                )}
            </VStack>
            <ErrorFieldNotification message={fieldState.error?.message} />
            {payoutMode === PayoutMode.Create && <AddNewAccountNotification />}
            <FirstPayoutNote />
        </Fragment>
    );
};
